import React from 'react';

const GlassCardMockup = ({ src }) => (
  <div className="relative w-full aspect-[4/5.5] bg-white/10 backdrop-blur-xl rounded-[1.5rem] md:rounded-[2rem] p-3 md:p-4 shadow-[0_30px_60px_rgba(0,0,0,0.3)] border border-white/20 transform transition-transform duration-500 hover:-translate-y-2 cursor-pointer overflow-hidden group">
    <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-white/10 to-transparent rounded-t-[2rem] pointer-events-none" />

    <div className="w-full h-full bg-white/5 rounded-[0.75rem] md:rounded-xl overflow-hidden border border-white/10 relative">
      <div className="absolute inset-0 bg-white/5 group-hover:bg-transparent transition-colors z-10 pointer-events-none" />
      <img
        src={src}
        className="w-full h-full object-cover opacity-95 group-hover:opacity-100 transition-opacity"
        alt="Voucher Creation"
      />
    </div>
  </div>
);

export default GlassCardMockup;
